exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  font-family: Roboto, 'Helvetica Neue', sans-serif; }\n  body * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n  body .mat-sidenav {\n    min-width: 15vw; }\n    body .mat-sidenav .mat-button {\n      width: 100%;\n      position: relative;\n      bottom: 0;\n      margin: 24px 0; }\n  body .sws-content {\n    padding: 32px;\n    box-sizing: border-box; }\n  body .mat-toolbar .mat-icon {\n    cursor: pointer; }\n  body .mat-toolbar .sws-toolbar {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100%; }\n  body h1 {\n    font-size: 20px; }\n\nh2 {\n  font-size: 16px;\n  color: red; }\n\n.sws-content {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box; }\n\n.company-image {\n  width: 140px;\n  height: 100px;\n  padding: 15px; }\n\n.seidler-image {\n  width: 300px;\n  height: 100px;\n  padding: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/infohome/infohome.component.scss
// module id = ../../../../../src/app/infohome/infohome.component.scss
// module chunks = 1